import Vue from 'vue';
import App from './App.vue';
import { Message, Icon } from 'element-ui';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from '@/store';
import axios from 'axios';
import moment from 'moment';
// @ts-ignore
import i18n from './language';

Vue.use(Element, {
  i18n: (key: any, value: any) => i18n.t(key, value)
});


Vue.config.productionTip = false;
axios.defaults.baseURL = '/reportweb';
Vue.prototype.$http = axios;
Vue.prototype.$message = Message;
Vue.component('el-icon', Icon);
// 过滤器定义
Vue.filter('toPercentage', (val: number) => {
  return ((val || 0) * 100).toFixed(2);
});
Vue.filter('formatTime', (val: string, format: string) => {
  const str = val ? moment(val).format(format) : '';
  if (i18n.locale != 'en') {

    return str;
  } else {
    if (val) {
      // 区分年月日和时分秒
      let suffix = str.substring(10,str.length);
      let enStr = new Date(val).toDateString().split(" ");
      enStr.splice(0, 1);
      return enStr.join(" ") + suffix;
    } else {
      return '';
    }
  }

});
Vue.filter('reportNum', (val: string, reportType: string) => {
  const reportTypeRelation: any = {
    simple: 'JM',
    originalText: 'BZ',
    preservation: 'CD',
    detailPart: 'XX',
    fullText: 'QW',
    OneByOne:'XX',
    simple_ft: 'JM',
    originalText_ft: 'BZ',
    detailPart_ft: 'XX',
    fullText_ft: 'QW',
    simple_en: 'CR',
    originalText_en: 'OT',
    detailPart_en: 'DF',
    fullText_en: 'FT'
  };
  const str = val + '-' + reportTypeRelation[reportType] || 'JM';
  return str;
});
Vue.filter('reportTypeRel', (val: string) => {
  const reportTypeRelation: any = {
    simple: i18n.t('app.simple'),
    originalText: i18n.t('app.origin'),
    detailPart: i18n.t('app.detail'),
    fullText: i18n.t('app.full'),
    preservation: i18n.t('app.preservation'),
    oneToOne: i18n.t('fOrH.oneReport'),
    simple_ft: i18n.t('app.simple'),
    originalText_ft: i18n.t('app.origin'),
    detailPart_ft: i18n.t('app.detail'),
    fullText_ft: i18n.t('app.full'),
    simple_en: i18n.t('app.simple'),
    originalText_en: i18n.t('app.origin'),
    detailPart_en: i18n.t('app.detail'),
    fullText_en: i18n.t('app.full')
  };
  if(i18n.locale == 'en') {
    return reportTypeRelation[val].toUpperCase() +' REPORT';
  }else {
    return reportTypeRelation[val];
  }
});

// @ts-ignore
new Vue({ store, i18n,
  render: (h) => h(App)
}).$mount('#app');
